import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Button
} from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { useTranslation } from 'react-i18next'

interface SuccessModalProps {
  open: boolean
  onClose: () => void
}

const SuccessModal: React.FC<SuccessModalProps> = ({ open, onClose }) => {
  const { t } = useTranslation()
  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          onClose()
        }
      }}
      maxWidth='xs'
      fullWidth
      PaperProps={{
        sx: { borderRadius: '12px', padding: '20px', textAlign: 'center' }
      }}
    >
      <DialogContent>
        <IconButton disableRipple disableFocusRipple>
          <CheckCircleIcon sx={{ fontSize: 60, color: 'green' }} />
        </IconButton>
        <Typography
          variant='h2'
          sx={{
            mt: '16px',
            textAlign: 'center'
          }}
        >
          {t('ourProducts.purchaseSuccessful')}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'center'
        }}
      >
        <Button
          variant='contained'
          sx={{
            backgroundColor: '#A11E20',
            color: '#fff',
            borderRadius: '8px',
            padding: '10px 20px'
          }}
          onClick={onClose}
        >
          {t('ourProducts.continueShopping')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SuccessModal
